import { useEffect, useState } from 'react'
import { Row, Col, Card } from "antd";
import { followingList, followerList } from "@/apis/user";
import UserCard from "@/components/UserCard";
import NoData from "@/components/NoData";

const UserList = ({ tabKey, type, uuid, pageParam, setTotal, pUuid }) => {
	const getList = () => {
		if (type === "2") {
			followingList({
				userUuid: uuid,
				...pageParam
			}).then(res => {
				setList(res.data.records)
				setTotal(res.data.total)
			})
		} else if (type === "1") {
			followerList({
				userUuid: uuid,
				...pageParam
			}).then(res => {
				setList(res.data.records)
				setTotal(res.data.total)
			})
		}
	}

	useEffect(() => {
		if (tabKey === "3" || tabKey === "4") {
			getList()
		}
	}, [pageParam, type, uuid])
	const [list, setList] = useState([]);

	const interact = (id, key, status) => {
		setList(list.map(item => {
			if (item.uuid === id) {
				return { ...item, [key]: status }
			} else return item
		}))
	}
	return <div>
		<Row gutter={30}>
			{
				list.map(item => {
					return <Col span={12} key={item + "_user"} style={{ marginBottom: "15px" }}>
						<Card>
							<UserCard info={item} interact={interact} pUuid={pUuid} />
						</Card>
					</Col>
				})
			}
		</Row>
		{list.length === 0 && <NoData />}
	</div>

}
export default UserList;